import { types, successAction } from "@authzsvc/api-lib";
import * as at from "../action-types";

const initialState = {
  application: {},
  roles: [],
  registrations: [],
  owner: {},
  new_registration: {},
  new_secret: {},
  fetchingOwner: false,
  groups: [],
  approvalRequiredModalOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case successAction(types.GET_APPLICATION):
      return { ...state, application: action.payload.data };
    case successAction(types.GET_ROLES):
      return { ...state, roles: action.payload.data };
    case successAction(types.GET_REGISTRATIONS):
      return {
        ...state,
        registrations: action.payload.data ? action.payload.data : [],
      };
    case successAction(types.GET_IDENTITY_MEMBERSHIPS):
      return { ...state, groups: action.payload.data };
    case successAction(types.REGISTER_APPLICATION): {
      const registrations = [...state.registrations, action.payload.data];
      return {
        ...state,
        registrations: registrations,
        new_registration: action.payload.data,
      };
    }
    case successAction(types.DELETE_REGISTRATION):
      return {
        ...state,
        registrations: state.registrations.filter(
          (registration) =>
            registration.registrationId !== action.payload.data.id,
        ),
      };
    case at.CLEAR_REGISTRATION_DETAILS:
      return { ...state, new_registration: {} };
    case successAction(types.REGENERATE_SECRET):
      return { ...state, new_secret: action.payload.data };
    case at.CLEAR_SECRET_DETAILS:
      return { ...state, new_secret: {} };
    case successAction(types.ADD_ROLE): {
      let new_roles = [...state.roles, action.payload.data];
      return { ...state, roles: new_roles };
    }
    case successAction(types.DELETE_ROLE):
      return {
        ...state,
        roles: state.roles.filter((role) => role.id !== action.payload.data.id),
      };
    case successAction(types.ADD_GROUP_MEMBER_IDENTITIES):
      if (action.payload.request_id) {
        return { ...state, approvalRequiredModalOpen: true };
      }
      return state;
    case at.CLOSE_APPROVAL_REQUIRED_MODAL:
      return { ...state, approvalRequiredModalOpen: false };
    case types.CLEAR_SELECTED_APPLICATION:
      return false;
    default:
      return state;
  }
};
